import { NewEpisodeSegmentFormProps } from './NewEpisodeSegmentForm';
import NewEpisodeSegmentModal from './NewEpisodeSegmentModal';

export default NewEpisodeSegmentModal;
export type { NewEpisodeSegmentFormProps };
